
import {defineComponent} from "vue";

export default defineComponent({
  name: "Name",

  props: {
    row: {
      type: Object,
      required: true,
    }
  },

  computed: {
    thumbnail(): null|string {
      return this.row?.facebook_ad_creative?.thumbnail_url ?? null;
    },
  }

});
